import { render, staticRenderFns } from "./BibleCloudChapterSelector.vue?vue&type=template&id=1867d5d8&scoped=true&"
import script from "./BibleCloudChapterSelector.vue?vue&type=script&lang=js&"
export * from "./BibleCloudChapterSelector.vue?vue&type=script&lang=js&"
import style0 from "./BibleCloudChapterSelector.vue?vue&type=style&index=0&id=1867d5d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1867d5d8",
  null
  
)

export default component.exports